import styles from "../index.module.less"
import { classModuleGenerator } from "@/utils"
const classnames = classModuleGenerator(styles)

function Reason(props) {
  const reasonList = [
    {
      name: "辅导经验",
      en: "Product",
      title: "25年高考经验",
      desc: "学大教育成立于2001年，拥有25年高考（升学）经验一直专注帮助学生升入理想院校；100+覆盖城市，50+全日制基地，A股上市教育公司可靠放心",
    },
    {
      name: "解决方案",
      en: "Solution",
      title: "定制化教学方案",
      desc: "科学入学评估，发现学生基础知识、学科素养、定制专属学习计划，辅助学生发现问题和解决学生当前学习问题",
    },
    {
      name: "精细化教学",
      en: "Fine teaching",
      title: "精细化小班教学",
      desc: "小班制教学，贴心照顾每个学生。学习管理师通过学生每次的考试结果，通过科学的学情分析，了解学生知识盲区，解决学生出现的问题，做到精细化教学管理",
    },
    {
      name: "四维服务",
      en: "Four dimensional service",
      title: "系统性四维服务",
      desc: "课程规划、心理疏导、家庭教育、志愿填报。四维服务随时关注学生学情，心理变化，帮助学生平衡心态",
    },
    {
      name: "学习环境",
      en: "academic environment",
      title: "安心的校园环境",
      desc: "合规资质、舒适环境、星级宿舍、营养膳食、卫生达标、 独立操场、标准实验室、新风全覆盖、监控无死角",
    },
  ]
  return (
    <section className={classnames("reason-container")}>
      <h3 className="section__title">为什么选择学大全日制</h3>
      <div className="section__inner">
        <ul className={styles["reason-list"]}>
          {reasonList.map((m, index) => {
            return (
              <li
                key={m.en}
                onClick={() => {
                  if (m.jumpUrl) window.open(m.jumpUrl)
                  else window.openJesongChatByGroup(121, 52601)
                  return false
                }}
              >
                <div
                  className={classnames("reason-item__poster")}
                  style={{
                    background: `url(${require(`@/assets/images/reason_${
                      index + 1
                    }.png`)}) no-repeat center/cover`,
                  }}
                >
                  <h4> {m.name}</h4>
                  <p> {m.en}</p>
                </div>
                <div className={classnames("reason-item__content")}>
                  <h4>{m.title}</h4>
                  <p>{m.desc}</p>
                  <button className="home-btn">
                    了解详情
                    {/* {model.btnText} */}
                  </button>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default Reason
